// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"06903662","149":"2305986c","400":"696b4c29","433":"faf438dd","523":"1e99b926","999":"f022c7d0"}[chunkId] + ".chunk.js";
};